<i18n>
en:
  title: "My page"
ja:
  title: "マイページ"
</i18n>

<template lang="pug">
  div
    v-img(src="@/assets/images/header-back-entry-user.png" min-height="180px")
      v-row.fill-height(align="center")
        v-col(align="center")
          h1.white--text|{{$t('title')}}

    router-view
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
h1
  font-size: 48px
  text-shadow: 0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2
  word-break: keep-all
</style>
